import React from "react";

// A tank drawn in SVG, filled to the current level, with dashed low/high marks.
function TankGauge({ pct, lowPct, highPct, size = 90, offline = false }) {
  const width = size;
  const height = size * 1.25;
  const pad = 4;
  const innerH = height - pad * 2;
  const clamped = pct == null ? 0 : Math.max(0, Math.min(100, pct));
  const fillH = (clamped / 100) * innerH;
  const y = (p) => pad + innerH - (p / 100) * innerH;
  const clipId = `tank-clip-${size}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={pct == null ? "Level unknown" : `${Math.round(pct)} percent full`}
      className="tank-gauge"
    >
      <rect x={pad} y={pad} width={width - pad * 2} height={innerH} rx={10} className="tank-shell" />
      <clipPath id={clipId}>
        <rect x={pad} y={pad} width={width - pad * 2} height={innerH} rx={10} />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect x={pad} y={pad + innerH - fillH} width={width - pad * 2} height={fillH} className={offline ? "tank-water stale" : "tank-water"} />
        {fillH > 0 && <rect x={pad} y={pad + innerH - fillH} width={width - pad * 2} height={3} className="tank-surface" />}
      </g>
      {lowPct != null && <line x1={pad} x2={width - pad} y1={y(lowPct)} y2={y(lowPct)} className="tank-mark" />}
      {highPct != null && <line x1={pad} x2={width - pad} y1={y(highPct)} y2={y(highPct)} className="tank-mark" />}
    </svg>
  );
}

export default TankGauge;
